// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"c8adfca2","487":"47717fb6"}[chunkId] + ".chunk.css";
};